import z from "zod";

export const TCreateFolderSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { message: "Folder name is required" })
    .max(255)
    .refine((val) => !val.includes("/"), {
      message: "Folder name cannot contain '/' character",
    }),
  project_id: z.string().nullable().optional(),
  description: z.string().max(1000).optional(),
  is_favorite: z.boolean().optional(),
});

export type TCreateFolder = z.infer<typeof TCreateFolderSchema>;
